import { AnimatePresence, motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { cn } from '@/Domain/utils/cn';

interface FieldMessageProps {
  id?: string;
  error?: string;
  hint?: string;
  action?: ReactNode;
  testId?: string;
}

// Renders unconditionally so a toggling message never re-flows the auth card and `id` stays a valid aria-describedby target.
export const FieldMessage = ({ id, error, hint, action, testId }: FieldMessageProps) => {
  const message = error ?? hint;

  return (
    <div id={id} data-testid={testId} aria-live="polite" className="min-h-5">
      <AnimatePresence mode="wait" initial={false}>
        {message && (
          <motion.p
            key={error ? `error:${error}` : `hint:${hint}`}
            initial={{ opacity: 0, y: -3 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -3 }}
            transition={{ duration: 0.15, ease: 'easeOut' }}
            className={cn(error ? 'text-sm text-destructive' : 'text-xs text-muted-foreground')}
          >
            {message}
            {action && <> {action}</>}
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  );
};
